import { render, staticRenderFns } from "./not-route.vue?vue&type=template&id=9e50e722&scoped=true&"
import script from "./not-route.vue?vue&type=script&lang=js&"
export * from "./not-route.vue?vue&type=script&lang=js&"
import style0 from "./not-route.vue?vue&type=style&index=0&id=9e50e722&lang=scss&scoped=true&"
import style1 from "./not-route.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e50e722",
  null
  
)

export default component.exports